import axios from "axios";
import { BASE_URL } from "../misc/Static_routes";
import { toast } from "react-toastify";
import { serverMessage } from "./serverMessage";
axios.defaults.withCredentials = true;

const notify = (message) => toast.error(`${message}`, {});
const notifySuccess = (message) => toast.success(`${message}`, {});
const notifyWarning = (message) => toast.warning(`${message}`, {});

export const addVote = async (data) => {
  const result = axios
    .post(`${BASE_URL}/api/designs/${data.design_id}/likes`, {data})
    .then((response) => {
      const responseOK =
        response && response.status === 200;
      if (responseOK) {
        notifySuccess(serverMessage(response?.data));
        return response.data;
      }
    })
    .catch((err) => {
      notify(serverMessage(err?.response?.data));
    });

  return result;
};

export const checkDesignIsLiked = async (data) => {
  const result = axios
    .post(`${BASE_URL}/api/designs/${data.design_id}/isLiked`, {data})
    .then((response) => {
      const responseOK =
        response && response.status === 200;
      if (responseOK) {
        if ( response?.data?.message ) {
          notifyWarning(serverMessage(response?.data));
        }
        return response.data;
      }
    })
    .catch((err) => {
      notify(serverMessage(err?.response?.data));
    });

  return result;
};